module.exports = __webpack_public_path__ + "img/apple.65be5d95.png";